import React from 'react';
import cookie from 'react-cookies';
import NavBar from '../layout/NavBar';
import TopBar from '../layout/TopBar';
import CreatePromoView from './CreatePromoView';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default class CreatePromoApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchPlaceholder: "Buscar promociones por código o nombre de producto"
    };
  }

  componentDidMount() {
    this.isUserLoggedIn()
  }

  isUserLoggedIn = () => {
    fetch(BACKEND_URL + '/users/current', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookie.load('token')
      }
    })
    .then(response => response.json())
    .then(data =>
      {
        if (Object.keys(data).length === 0) {
          window.location = '/'
        }
      }
    )
    .catch(e => console.log(e));
  };

  handleSearch = event => {
    // search action occurs after ENTER is pressed
    if(event.keyCode === 13) {
      // to disbale default submit form
      event.preventDefault();
      let query = event.target.value;
      let val = window.confirm("¿Esta seguro que quiere continuar? Los cambios editados no seran guardados");
      if (val) {
        if (query !== '') {
          // redirecting to index accroding to clicked
          window.location = '/promociones?query=' + query
        }
      }
      event.target.value = ''
    }
  };

  render() {
    return (
      <div>
        <div>
          <div onKeyDown={this.handleSearch}>
            <TopBar searchPlaceholder={this.state.searchPlaceholder}/>
          </div>
          <div>
            <CreatePromoView />
          </div>
        </div>
        <div>
          <NavBar activeItem='Promociones' isEditing={true}/>
        </div>
      </div>
    )
  }
}
